import { createRegisterableComponent } from 'common/routing/page-definition'

export const ComponentRendererErrorRegistration = createRegisterableComponent(
    'component-renderer-error-test',
    () => {
        throw new Error('ComponentRenderer test error')
    }
)
